import { render } from "./TopWarnings.vue?vue&type=template&id=ab4937d0&scoped=true"
import script from "./TopWarnings.vue?vue&type=script&lang=js"
export * from "./TopWarnings.vue?vue&type=script&lang=js"

import "./TopWarnings.vue?vue&type=style&index=0&id=ab4937d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4937d0"]])

export default __exports__